"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var PopupLoader_1 = require("@tobidot/js-popup-handler/src/lib/ts/PopupLoader");
function init() {
    var popup_loader = new PopupLoader_1.PopupLoader();
    window.popups = popup_loader;
    popup_loader.load();
}
exports.init = init;
